import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './rejection-reason.reducer';

export interface IRejectionReasonAmbulanceDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const RejectionReasonAmbulanceDetail = (props: IRejectionReasonAmbulanceDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { rejectionReasonAmbulanceEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          RejectionReasonAmbulance [<b>{rejectionReasonAmbulanceEntity.id}</b>]
        </h2>

        <dl className="jh-entity-details">
          <dt>
            <span id="description">Rejection Reason (English)</span>
          </dt>
          <dd>{rejectionReasonAmbulanceEntity.enRejectionReason}</dd>
        </dl>

        <dl className="jh-entity-details">
          <dt>
            <span id="description">Rejection Reason (Local Language)</span>
          </dt>
          <dd>{rejectionReasonAmbulanceEntity.stRejectionReason}</dd>
        </dl>
        <dl className="jh-entity-details">
          <dt>
            <span id="description">Active</span>
          </dt>
          <dd>{rejectionReasonAmbulanceEntity.isActive ? 'Yes' : 'No'}</dd>
        </dl>
        <Button tag={Link} to="/rejection-reasons-ambulance" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/rejection-reasons-ambulance/${rejectionReasonAmbulanceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ rejectionReasonAmbulance }: IRootState) => ({
  rejectionReasonAmbulanceEntity: rejectionReasonAmbulance.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RejectionReasonAmbulanceDetail);
